import { Component, ElementRef, inject, input, output, viewChild } from '@angular/core'
import { NgTemplateOutlet } from '@angular/common'
import { BottomSheetComponent } from '../bottom-sheet/bottom-sheet.component'
import { ContentBlockComponent } from '../content-block/content-block.component'
import { ContentItemComponent } from '../content-item/content-item.component'
import type { SwipeRowAction } from './swipe-row.component'
import { IconsDirective } from '@awork/_shared/directives/icons/icons.directive'

let nextTitleId = 0

/** Shows the existing row actions in the shared mobile sheet. */
@Component({
  selector: 'aw-row-actions-sheet',
  templateUrl: './row-actions-sheet.component.html',
  styleUrl: './row-actions-sheet.component.scss',
  imports: [BottomSheetComponent, ContentBlockComponent, ContentItemComponent, NgTemplateOutlet, IconsDirective]
})
export class RowActionsSheetComponent {
  readonly elementRef = inject(ElementRef)
  readonly label = input.required<string>()
  readonly actions = input.required<readonly SwipeRowAction[]>()
  /** Emits during the tap so browser actions can retain user activation. */
  readonly selected = output<string>()
  /** Emits after dismissal, so action editors open above the original screen. */
  readonly closed = output<string | undefined>()
  protected readonly titleId = `row-actions-title-${nextTitleId++}`
  protected readonly commonTranslations = q.translations.common
  private readonly sheet = viewChild.required(BottomSheetComponent)
  private selection?: string

  /**
   * Emits the selection during the tap, then dismisses.
   * @param {SwipeRowAction} action Chosen row action.
   */
  protected select(action: SwipeRowAction): void {
    if (action.disabled || this.sheet().closing()) {
      return
    }

    this.selection = action.id
    this.selected.emit(action.id)
    this.sheet().onClose()
  }

  /** Returns the selection once the sheet has finished closing. */
  finish(): void {
    this.closed.emit(this.selection)
  }
}
